/*=============================================== Footer styles ===============================================*/

import styled from "styled-components/macro"
import { Spacers, Mixins, Breakpoints } from "tsx-library-julseb"

export const StyledFooter = styled.footer`
    width: 800px;
    padding: ${Spacers.L} 0 ${Spacers.L};
    position: relative;
    ${Mixins.Flexbox({
        $justifyContent: "center",
    })};

    &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: ${({ theme }) => theme.Gray100};
        top: 0;
        left: 0;
    }

    @media ${Breakpoints.Tablet} {
        width: 90%;
    }
`
